import * as THREE from 'three'
class TextureAnimator {
  constructor (texture, tilesHoriz, tilesVert, numTiles, tileDispDuration) {
    this.tilesHorizontal = tilesHoriz
    this.tilesVertical = tilesVert
    this.numberOfTiles = numTiles
    texture.wrapS = texture.wrapT = THREE.RepeatWrapping
    texture.repeat.set(1 / this.tilesHorizontal, 1 / this.tilesVertical)

    this.tileDisplayDuration = tileDispDuration

    this.currentDisplayTime = 0

    this.currentTile = numTiles

    this.update = function (milliSec) {
      this.currentDisplayTime += milliSec
      while (this.currentDisplayTime > this.tileDisplayDuration) {
        this.currentDisplayTime -= this.tileDisplayDuration
        this.currentTile--

        const currentColumn = this.currentTile % this.tilesHorizontal
        texture.offset.x = currentColumn / this.tilesHorizontal
        const currentRow = Math.floor(this.currentTile / this.tilesHorizontal)

        texture.offset.y = currentRow / this.tilesVertical
        if (this.currentTile === 1) {
          this.currentTile = numTiles
        }
      }
    }
  }
}
export { TextureAnimator }
